<template>
  <div class="dates">
    <div class="dates__item">
      <label class="label-control">Дата заезда</label>
      <div class="input-group">
        <datepicker
          v-model="dateFrom"
          :full-month-name="true"
          :monday-first="true"
          :language="ru"
          :disabled-dates="state.disabledDateFrom"
        ></datepicker>
      </div>
    </div>
    <div class="dates__item dates__item_nights">
      <label class="label-control">Ночей</label>
      <div class="input-group">
        <div class="input-group-btn" style="padding: 0">
          <button
            @click="subtractNight()"
            class="btn btn-sm btn-round"
            type="submit"
            style="padding: 6px 10px 5px 10px"
          >
            <i class="glyphicon glyphicon-minus"></i>
          </button>
        </div>
        <input
          v-model="nights"
          disabled
          type="number"
          style="text-align: center"
          size="5px"
          min="1"
          max="10"
          class="dates__days"
        />
        <div class="input-group-btn" style="padding: 0">
          <button
            @click="addNight()"
            class="btn btn-sm btn-round"
            type="submit"
            style="padding: 6px 10px 5px 10px"
          >
            <i class="glyphicon glyphicon-plus"></i>
          </button>
        </div>
      </div>
    </div>
    <div class="dates__item">
      <label class="label-control">Дата выезда</label>
      <div class="input-group">
        <datepicker
          v-model="dateTo"
          :monday-first="true"
          :full-month-name="true"
          :language="ru"
          :disabled-dates="state.disabledDateTo"
        ></datepicker>
      </div>
    </div>
  </div>
</template>
<script>
import Datepicker from 'vuejs-datepicker';
import { ru } from 'vuejs-datepicker/dist/locale';
import moment from 'moment';

export default {
  name: 'DatePicker',

  components: {
    Datepicker,
  },

  data() {
    return {
      ru,
      validationError: null,
      dateFrom: moment().format('YYYY-MM-DD'),
      nights: 1,
      state: {
        disabledDateTo: {
          to: new Date(moment().add(1, 'days').format('YYYY, MM, DD')),
        },
        disabledDateFrom: {
          to: new Date(moment().format('YYYY, MM, DD')),
        },
      },
    };
  },
  computed: {
    disabledDateTo() {
      return {
        to: new Date(moment(this.dateFrom).add(1, 'days').format('YYYY, MM, DD')),
      };
    },
    dateTo: {
      get() {
        return moment(this.dateFrom).add(this.nights, 'days').format('YYYY-MM-DD');
      },
      set(newDateToValue) {
        const date1 = moment(this.dateFrom).format('YYYY-MM-DD');
        const date2 = moment(newDateToValue).format('YYYY-MM-DD');
        this.nights = moment(date2).diff(date1, 'days');
      },
    },
    dateRange() {
      return {
        date_from: this.dateFrom ? moment(this.dateFrom).format('YYYY-MM-DD') : null,
        date_to: this.dateTo ? moment(this.dateTo).format('YYYY-MM-DD') : null,
      };
    },
  },
  mounted() {
    this.$emit('dateRangeChanged', this.dateRange);
  },
  watch: {
    dateRange: {
      // eslint-disable-next-line no-unused-vars
      handler(val, oldVal) {
        if (this.dateFrom && !this.dateTo) {
          this.validationError = 'Укажите дату выезда';
        } else {
          this.validationError = null;
        }
        if (this.dateFrom && this.dateTo) {
          if (!moment(this.dateFrom).isBefore(this.dateTo)) {
            this.validationError = 'Дата выезда должна больше даты заезда!';
          } else {
            this.validationError = null;
          }
        }
        if (!this.validationError && this.dateFrom && this.dateTo) {
          this.$emit('dateRangeChanged', this.dateRange);
        } else {
          this.$emit('dateRangeChanged', null);
        }
      },
    },
  },
  methods: {
    addNight() {
      this.nights += 1;
    },
    subtractNight() {
      if (this.nights > 1) {
        this.nights -= 1;
      }
    },
    moment() {
      return moment();
    },
  },
};
</script>

<style lang="sass">
@mixin mobile
  @media screen and (max-width: 990px)
    @content

.dates
  display: flex
  justify-content: space-evenly
  float: left
  width: 50%
  @include mobile
    flex-wrap: wrap
    justify-content: flex-start

  &__item
    width: 33.3%
    flex-basis: 33.3%
    padding-right: 10px
    @include mobile
      width: auto
      flex-basis: auto
      padding-bottom: 10px
    &_nights
      width: auto
      flex-basis: auto
      @include mobile
        order: 3
        width: auto
        flex-basis: auto
        padding: 0

  &__days
    width: 39px
    -moz-appearance: textfield

    &::-webkit-inner-spin-button
    &::-webkit-outer-spin-button
      -webkit-appearance: none
      margin: 0
</style>
